import Index from '../../adminNew/resetPassword/index.vue'
import BlankLayout from '../layout/blankLayout.vue'

const basePath = '/v-agency/reset-password'

export default {
  path: basePath,
  redirect: basePath,
  component: BlankLayout,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.resetPassword.menu.resetPassword'
  },
  children: [
    {
      path: basePath,
      component: Index,
      meta: {
        titleI18nKey: 'admin.resetPassword.menu.resetPassword'
      }
    }
  ]
}
